
import $ from 'jquery';


class FitanalyticsHandlerClass {
	constructor() {
		// Automatically open the Fitanalytics Popup after consent confirmation.
		document.addEventListener( 'click', ( ev ) => {
			if ( ev.target.matches( '.js-usercentrics-accept-fitanalytics' ) ) {
				this.handleConsentClick();
			}
		} );

		// Update button text in specific cases.
		window.addEventListener( 'fitanalytics.acl', ( ev ) => this.handleCustomButton( ev ) );

		// Do not open the consent popup if it does not need to be opened.
		document.addEventListener( 'open_popup.sl', ( ev ) => this.handlePopupOpen( ev ) );

		// Initialise Fitanalytics with each reload of product.
		document.addEventListener( 'finished_change_variant', ( ev ) => {

			// Initialisation.
			const containerEl = ev.target;
			initFitanalytics( containerEl );
		} );
	}

	openWidget() {
		const _fitAnalytics = window._fitAnalytics;
		setTimeout( () => {
			if ( _fitAnalytics && _fitAnalytics.widget ) {
				_fitAnalytics.widget.open();
			}
		}, 500 );
	}

	handleConsentClick( ev ) {
		// Click on the confirm button in the popup.
		document.addEventListener( 'fitanalytics_button_added.acl', () => this.openWidget(), { once: true } );
	}

	handleCustomButton( ev ) {
		const helper = window._fitAnalytics && window._fitAnalytics.shop;
		if ( ! helper ) {
			return;
		}

		const { action } = ev.detail;
		switch ( action ) {
			case 'onProductLoaded':
			case 'onProductChange':
				const product = helper.getContext( helper.getCurrentSerial() );
				const $buttonTextEl = helper.find( '.fitanalytics__button_custom .fitanalytics__button-text' );
				if ( ! product.isSupported ) {
					$buttonTextEl.text( "Für dieses Produkt ist unser Auswahlassistent leider nicht verfügbar!" );
				} else {
					$buttonTextEl.text( "Welche Größe passt mir?" );
				}
			break;
		}
	}

	handlePopupOpen( ev ) {
		// Any other popup.
		if ( ! ev.target.matches( '#popup_customconsent_fitanalytics' ) ) {
			return;
		}

		// FitAnalytics not loaded yet.
		const helper = window._fitAnalytics && window._fitAnalytics.shop;
		if ( ! helper ) {
			return;
		}

		// Do not open Popup when the current product is not supported.
		const product = helper.getContext( helper.getCurrentSerial() );
		if ( ! product.isSupported ) {
			ev.preventDefault();
		}
	}
}

const initFitanalytics = function( scopeEl = document ) {

    const containerEl = scopeEl.querySelector( '#variants' );
	if ( ! containerEl ) {
		return;
	}

    const sizeInputEls = Array.from( containerEl.querySelectorAll( '.acl_js--size_choice_input' ) );
    const colorInputEls = Array.from( containerEl.querySelectorAll( '.acl_js--color_choice_input' ) );

    const mainImageEl = document.querySelector( 'div[data-en-photoswipe-url]' );

	const findSizeInput = ( size ) => {

		const wrapperEl = scopeEl.getElementById( 'size_select_wrapper' );
		const inputEls = Array.from( wrapperEl.querySelectorAll( '.acl_js--size_choice_input' ) );
		return Array.from( inputEls ).find( inputEl => inputEl.dataset.sizeLabel === size );
	};

    const fitAnalyticsData = {
        shopLanguage: 'de',
        shopCountry: v_country.toUpperCase(),
        mainImageLink: mainImageEl?.dataset.enPhotoswipeUrl || '',
        userId: EN.Cookies.get( 'fitFinderId' ) ?? null,
        currentItemSubgroupId: colorInputEls.find( inputEl => inputEl.checked )?.value,
        allItemSubgroupIds: colorInputEls.map( inputEl => inputEl.value ),
        shopSessionId: EN.Cookies.get( '_gid' ),
        sizes: sizeInputEls.map( inputEl => {
            return {
                value: inputEl.dataset.sizeLabel,
                isAvailable: !inputEl.disabled,
            };
        } ),
        operations: {
            getAddToCartBtn: function () {
                return document.querySelector( '.to_cart' );
            },
            getSizeChartLink: function () {
                return document.getElementById( 'size-table-link' );
            },
            addToCart: function( currentItemSubgroupId, size ) {

				const inputEl = findSizeInput( size );

				const detailsEl = containerEl.closest( '#details_container' );
				const VariantHandler = detailsEl.ACL_Article_Variant;

				// Change to correct size, if necessary.
				VariantHandler.setSize( inputEl.value ).then( () => {
					// Add to Basket.
					detailsEl.querySelector( '.to_cart' ).click();
				} );
            },
            selectSize: function( currentItemSubgroupId, size ) {
				const inputEl = findSizeInput( size );
				inputEl.click(); // Trigger change event.
            },
            getCurrentSize: function () {
                const wrapperEl = scopeEl.getElementById( 'size_select_wrapper' );
                return wrapperEl.querySelector( 'input:checked' )?.nextElementSibling?.innerText || '';
            },
            getCartItems: function(){
                return AclMiniBasket.items;
            }
        }
    };

    window.fitAnalyticsData = fitAnalyticsData;
};

const FitanalyticsHandler = new FitanalyticsHandlerClass();

export {
	initFitanalytics,
	FitanalyticsHandler as default,
};
